import { render, staticRenderFns } from "./DashboardFilter.vue?vue&type=template&id=8f0ef9f2&"
import script from "./DashboardFilter.vue?vue&type=script&lang=js&"
export * from "./DashboardFilter.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFilter.vue?vue&type=style&index=0&id=8f0ef9f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports